import { lazy } from "react";



const Wms = lazy(() => import("./Wms"));

const WmsAuth = lazy(() => import("./OpenWms/WmsAuth"));

const ShipmentVoucherReceipt = lazy(() => import("./ShipmentVoucherReceipt/ShipmentVoucherReceipt"));

const ShipmentVoucherMenu = lazy(() => import("./ShipmentVoucherReceipt/ShipmentVoucherMenu"));

const BoxScan = lazy(() => import("./Scan/BoxScan"));

const BoxOpenScan = lazy(() => import("./Scan/BoxOpenScan"));

const ItemsScan = lazy(() => import("./Scan/ItemsScan"));

const BoxesInfos = lazy(() => import("./Scan/BoxesInfos"));

const BinsDetails = lazy(() => import("./BinsContenu/BinsDetails"));

const ZoneDetails = lazy(() => import("./ZoneContenu/ZoneDetails"));

const StockMovement = lazy(() => import("./StockMovement/StockMovement"));

const StockMovementBins = lazy(() => import("./StockMovement/StockMovementBins"));

const StockMovementZone = lazy(() => import("./StockMovement/StockMovementZone"));

const PoB2cPicked = lazy(() => import("./PoB2c/PoB2cPicked"));

const PoB2cChemin = lazy(() => import("./PoB2c/PoB2cChemin"));

const ItemScanEcom = lazy(() => import("./PoB2c/Comp/ItemScanEcom"));

const ToPickedHome = lazy(() => import("./To/ToPickedHome"));

const ToPicked = lazy(() => import("./To/ToPicked"));

const ToScanItem = lazy(() => import("./To/Picked/ToScanItem"));

const ToReceive = lazy(() => import("./To/ToReceive"));

const ToConsultation = lazy(() => import("./To/ToConsultation"));

const ToReceiveBefore = lazy(() => import("./To/Receive/ToReceiveBefore"));

const ToScanArticle = lazy(() => import("./To/Receive/ReceiveComponents/ToScanArticle"));

const ItemDetailsWms = lazy(() => import("./ItemDetailsWms/ItemDetailsWms"));

const PeripheriqueWms = lazy(() => import("./PeripheriqueWms/PeripheriqueWms"));

const InventoryWms = lazy(() => import("./InventoryWms/InventoryWms"));

const CategoryInventoryWms = lazy(() => import("./InventoryWms/CategoryInventoryWms"));

const ZoneInventoryWms = lazy(() => import("./InventoryWms/ZoneInventoryWms"));

const BinsInventoryWms = lazy(() => import("./InventoryWms/BinsInventoryWms"));

const ZoneInventoryScanWms = lazy(() => import("./InventoryWms/Comp/ZoneInventoryScanWms"));

const BinsInventoryScanWms = lazy(() => import("./InventoryWms/Comp/BinsInventoryScanWms"));

const CategoryInventoryScanWms = lazy(() => import("./InventoryWms/Comp/CategoryInventoryScanWms"));

const NotificationListWms = lazy(() => import("./Notification/NotificationListWms"));

const NotificationDetailWms = lazy(() => import("./Notification/NotificationDetailWms"));

const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));

const HistoriqueDetail = lazy(() => import("./Historique/HistoriqueDetail"));

const ReassortInterneMouvment = lazy(() => import("./ReassortInterneMouvment/ReassortInterneMouvment"));

const ReassortInterneChooseZone = lazy(() => import("./ReassortInterneMouvment/ReassortInterneChooseZone"));

const ReassortInterneMouvmentDetail = lazy(() => import("./ReassortInterneMouvment/ReassortInterneMouvmentDetail"));

const PurchaseOrderReceipt = lazy(() => import("./PurchaseOrderReceipt/PurchaseOrderReceipt"))

const PurchaseOrderReceiptScan = lazy(() => import("./PurchaseOrderReceipt/Comp/PurchaseOrderReceiptScan"))

const MultiPurchaseOrderReceiptScan = lazy(() => import("./PurchaseOrderReceipt/Comp/MultiPurchaseOrderReceiptScan"))

const ListeArticle = lazy(() => import("./ListeArticle/ListeArticle"));

const ListeArticleDetailAdd = lazy(() => import("./ListeArticle/ListeArticleDetailAdd"));

const Test = lazy(() => import("./Test"));

const WmsReport = lazy (()=> import("./ReportPbi/WmsReport"))

const PoB2b = lazy (()=> import("./PoB2b/PoB2b"))

const PoB2bCollect = lazy (()=> import("./PoB2b/Comp/PoB2bCollect"))

const ItemScanB2b = lazy (()=> import("./PoB2b/Comp/ItemScanB2b"))

const ReturnNote = lazy (()=> import("./ReturnNote/ReturnNote"))

const ReturnNoteReceipt = lazy (()=> import("./ReturnNote/Comp/ReturnNoteReceipt"))

const CreateDeliveryNote = lazy (()=> import("./Livraison/CreateDeliveryNote"))

const DeliveryNoteInProgressList = lazy (()=> import("./Livraison/DeliveryNoteInProgressList"))

const ValidationDeliveryNote = lazy (()=> import("./Livraison/ValidationDeliveryNote"))

const DeliveryNoteAddItem = lazy (()=> import("./Livraison/DeliveryNoteAddItem/DeliveryNoteAddItem"))

const DeliveryNoteDetail = lazy (()=> import("./Livraison/ValidationComp/DeliveryNoteDetail"))

const StockAdjustment = lazy (()=> import("./StockAdjustment/StockAdjustment"))



/**********!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!***************** */

/*     Toutes les routes WMS doivent commencer par wms/:wmsid            */

/*     A part la route d'authentification badge (wms_auth_required)      */

/**********!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!***************** */

const wmsRoutes = [
    // ─── Authentification & accueil ────────────────────────────────────────────
    {
        exact:true,
        path: "/wmsauth/:wmsid",
        id: "wms_auth",
        // name: "[WMS] Authentification badge - /wmsauth/:wmsid",
        component: WmsAuth
    },
    {
        exact:true,
        path: "/wms/:wmsid",
        id: "wms_home",
        // name: "[WMS] Accueil - /wms/:wmsid",
        component: Wms
    },
    // ─── Détail article / bin / zone ───────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/item-details/:articleref",
        id: "wms_item_details",
        name: "[WMS] Détail article - /wms/:wmsid/item-details/:articleref",
        component: ItemDetailsWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/bins-scan",
        id: "wms_bins_scan",
        name: "[WMS] Contenu d'un bin - /wms/:wmsid/bins-scan",
        component: BinsDetails
    },
    {
        exact:true,
        path: "/wms/:wmsid/zone-content",
        id: "wms_zone_content",
        name: "[WMS] Contenu d'une zone - /wms/:wmsid/zone-content",
        component: ZoneDetails
    },
    // ─── Mouvements de bins ────────────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/bins-movement",
        id: "wms_bins_movement",
        name: "[WMS] Mouvements de stock - /wms/:wmsid/bins-movement",
        component: StockMovement
    },
    {
        exact:true,
        path: "/wms/:wmsid/bins-movement/bins/:binsid",
        id: "wms_bins_movement_bins",
        name: "[WMS] Mouvements de stock par bin - /wms/:wmsid/bins-movement/bins/:binsid",
        component: StockMovementBins
    },
    {
        exact:true,
        path: "/wms/:wmsid/bins-movement/zone/:zoneid",
        id: "wms_bins_movement_zone",
        name: "[WMS] Mouvements de stock par zone - /wms/:wmsid/bins-movement/zone/:zoneid",
        component: StockMovementZone
    },
    // ─── Collecte : ordres de transfert ────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/transfer-orders-collect",
        id: "wms_transfer_orders_collect",
        name: "[WMS] Collecte des ordres de transfert - /wms/:wmsid/transfer-orders-collect",
        component: ToPickedHome
    },
    {
        exact:true,
        path: "/wms/:wmsid/transfer-order/:toid",
        id: "wms_transfer_order_picked",
        name: "[WMS] Collecte d'un ordre de transfert - /wms/:wmsid/transfer-order/:toid",
        component: ToPicked
    },
    {
        exact:true,
        path: "/wms/:wmsid/transfer-order/:toid/:zoneid/item-scan/:zoneparam/:id/:zonename/:toref/:fsection",
        id: "wms_transfer_order_item_scan",
        name: "[WMS] Scan article - collecte ordre de transfert - /wms/:wmsid/transfer-order/:toid/:zoneid/item-scan/:zoneparam/:id/:zonename/:toref/:fsection",
        component: ToScanItem
    },
    // ─── Collecte : commandes e-commerce (B2C) ─────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/ecom-collect",
        id: "wms_ecom_collect",
        name: "[WMS] Collecte commande B2C - /wms/:wmsid/ecom-collect",
        component: PoB2cPicked
    },
    {
        exact:true,
        path: "/wms/:wmsid/ecom-collect/:toid",
        id: "wms_ecom_collect_path",
        name: "[WMS] Chemin de collecte commande B2C - /wms/:wmsid/ecom-collect/:toid",
        component: PoB2cChemin
    },
    {
        exact:true,
        path: "/wms/:wmsid/ecom-collect/:toid/:zoneid/item-scan/:zoneparam/:binsid/:zonename/:toref",
        id: "wms_ecom_collect_item_scan",
        // name: "[WMS] Scan article - collecte e-commerce - /wms/:wmsid/ecom-collect/:toid/:zoneid/item-scan/:zoneparam/:binsid/:zonename/:toref",
        component: ItemScanEcom
    },
    // ─── Collecte : commandes B2B ──────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/b2b/purchase-order",
        id: "wms_b2b_purchase_order",
        name: "[WMS] Collecte commandes B2B - /wms/:wmsid/b2b/purchase-order",
        component: PoB2b
    },
    {
        exact:true,
        path: "/wms/:wmsid/b2b/purchase-order/collection/:id",
        id: "wms_b2b_purchase_order_collection",
        name: "[WMS] Collecte d'une commande B2B - /wms/:wmsid/b2b/purchase-order/collection/:id",
        component: PoB2bCollect
    },
    {
        exact:true,
        path: "/wms/:wmsid/b2b/purchase-order/item-scan/:id/:zoneid/:zoneparam/:binsref/:zonename/",
        id: "wms_b2b_purchase_order_item_scan",
        // name: "[WMS] Scan article - collecte commande B2B - /wms/:wmsid/b2b/purchase-order/item-scan/:id/:zoneid/:zoneparam/:binsref/:zonename/",
        component: ItemScanB2b
    },
    // ─── Réception : ordres de transfert ───────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/transfer-orders-receive",
        id: "wms_transfer_orders_receive",
        name: "[WMS] Réception des ordres de transfert - /wms/:wmsid/transfer-orders-receive",
        component: ToReceive
    },
    {
        exact:true,
        path: "/wms/:wmsid/transfer-orders-receive/:toid/:zonename",
        id: "wms_transfer_order_receive_before",
        name: "[WMS] Préparation réception ordre de transfert - /wms/:wmsid/transfer-orders-receive/:toid/:zonename",
        component: ToReceiveBefore
    },
    {
        exact:true,
        path: "/wms/:wmsid/transfer-orders-receive/:toid/:zonename/:toref/scan",
        id: "wms_transfer_order_receive_scan",
        // name: "[WMS] Scan article - réception ordre de transfert - /wms/:wmsid/transfer-orders-receive/:toid/:zonename/:toref/scan",
        component: ToScanArticle
    },
    // ─── Réception : bons d'expédition ─────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/shipment-voucher-receipt",
        id: "wms_shipment_voucher_receipt",
        // name: "[WMS] Réception des bons d'expédition - /wms/:wmsid/shipment-voucher-receipt",
        component: ShipmentVoucherReceipt
    },
    // ─── Réception : bons de commande ──────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/purchase-order-receipt",
        id: "wms_purchase_order_receipt",
        name: "[WMS] Réception des bons de commande - /wms/:wmsid/purchase-order-receipt",
        component: PurchaseOrderReceipt
    },
    {
        exact:true,
        path: "/wms/:wmsid/purchase-order/receipt/:id",
        id: "wms_purchase_order_receipt_scan",
        // name: "[WMS] Scan réception bon de commande - /wms/:wmsid/purchase-order/receipt/:id",
        component: PurchaseOrderReceiptScan
    },
    {
        exact:true,
        path: "/wms/:wmsid/purchase-order/multi-receipt/:poids",
        id: "wms_purchase_order_multi_receipt_scan",
        // name: "[WMS] Scan réception multi bons de commande - /wms/:wmsid/purchase-order/multi-receipt/:poids",
        component: MultiPurchaseOrderReceiptScan
    },
    // ─── Réception : bons de retour ────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/b2b/return-note",
        id: "wms_return_note",
        name: "[WMS] Bons de retour - /wms/:wmsid/b2b/return-note",
        component: ReturnNote
    },
    {
        exact:true,
        path: "/wms/:wmsid/b2b/return-note/receipt/:id",
        id: "wms_return_note_receipt",
        // name: "[WMS] Réception d'un bon de retour - /wms/:wmsid/b2b/return-note/receipt/:id",
        component: ReturnNoteReceipt
    },
    // ─── Livraison ─────────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/delivery-note/create",
        id: "wms_delivery_note_create",
        name: "[WMS] Créer un bon de livraison - /wms/:wmsid/delivery-note/create",
        component: CreateDeliveryNote
    },
    {
        exact:true,
        path: "/wms/:wmsid/delivery-note/:id/add-items",
        id: "wms_delivery_note_add_items",
        name: "[WMS] Ajout d'articles au bon de livraison - /wms/:wmsid/delivery-note/:id/add-items",
        component: DeliveryNoteAddItem
    },
    {
        exact:true,
        path: "/wms/:wmsid/delivery-note/in-progress",
        id: "wms_delivery_note_in_progress",
        name: "[WMS] Bons de livraison en cours - /wms/:wmsid/delivery-note/in-progress",
        component: DeliveryNoteInProgressList
    },
    {
        exact:true,
        path: "/wms/:wmsid/delivery-note/validation",
        id: "wms_delivery_note_validation",
        name: "[WMS] Validation des bons de livraison - /wms/:wmsid/delivery-note/validation",
        component: ValidationDeliveryNote
    },
    {
        exact:true,
        path: "/wms/:wmsid/delivery-note/detail/:id",
        id: "wms_delivery_note_detail",
        name: "[WMS] Détail bon de livraison - /wms/:wmsid/delivery-note/detail/:id",
        component: DeliveryNoteDetail
    },
    // ─── Divers : listes d'articles ────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/list-items",
        id: "wms_list_items",
        name: "[WMS] Listes d'articles - /wms/:wmsid/list-items",
        component: ListeArticle
    },
    {
        exact:true,
        path: "/wms/:wmsid/list-items-details/:listId",
        id: "wms_list_items_details",
        name: "[WMS] Détail liste d'articles - /wms/:wmsid/list-items-details/:listId",
        component: ListeArticleDetailAdd
    },
    // ─── Divers : consultation, ajustement, réassort ───────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/transfer-orders-consultation",
        id: "wms_transfer_orders_consultation",
        name: "[WMS] Consultation des ordres de transfert - /wms/:wmsid/transfer-orders-consultation",
        component: ToConsultation
    },
    {
        exact:true,
        path: "/wms/:wmsid/stock-adjustment",
        id: "wms_stock_adjustment",
        name: "[WMS] Ajustement de stock - /wms/:wmsid/stock-adjustment",
        component: StockAdjustment
    },
    {
        exact:true,
        path: "/wms/:wmsid/reassort_interne",
        id: "wms_reassort_interne",
        name: "[WMS] Réassort interne - /wms/:wmsid/reassort_interne",
        component: ReassortInterneMouvment
    },
    {
        exact:true,
        path: "/wms/:wmsid/reassort_interne/:reassort_interne_id",
        id: "wms_reassort_interne_zone",
        // name: "[WMS] Réassort interne - choix de la zone - /wms/:wmsid/reassort_interne/:reassort_interne_id",
        component: ReassortInterneChooseZone
    },
    {
        exact:true,
        path: "/wms/:wmsid/reassort_interne/:reassort_interne_id/:zone_id",
        id: "wms_reassort_interne_detail",
        name: "[WMS] Réassort interne - détail - /wms/:wmsid/reassort_interne/:reassort_interne_id/:zone_id",
        component: ReassortInterneMouvmentDetail
    },
    // ─── Divers : inventaire ───────────────────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/inventory",
        id: "wms_inventory",
        name: "[WMS] Inventaire - /wms/:wmsid/inventory",
        component: InventoryWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/categorie/:inventoryname/:zoneid/:id",
        id: "wms_inventory_category",
        name: "[WMS] Inventaire par catégorie - /wms/:wmsid/inventory/categorie/:inventoryname/:zoneid/:id",
        component: CategoryInventoryWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/categorie/:inventoryname/:zoneid/:id/:rhid",
        id: "wms_inventory_category_scan",
        // name: "[WMS] Inventaire par catégorie - scan - /wms/:wmsid/inventory/categorie/:inventoryname/:zoneid/:id/:rhid",
        component: CategoryInventoryScanWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/zone/:inventoryname/:zoneid/:id",
        id: "wms_inventory_zone",
        name: "[WMS] Inventaire par zone - /wms/:wmsid/inventory/zone/:inventoryname/:zoneid/:id",
        component: ZoneInventoryWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/zone/:inventoryname/:zoneid/:id/:zoneiventoryid/:rhid/:zoneinventoryname",
        id: "wms_inventory_zone_scan",
        // name: "[WMS] Inventaire par zone - scan - /wms/:wmsid/inventory/zone/:inventoryname/:zoneid/:id/:zoneiventoryid/:rhid/:zoneinventoryname",
        component: ZoneInventoryScanWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/bins/:inventoryname/:zoneid/:id",
        id: "wms_inventory_bins",
        name: "[WMS] Inventaire par bin - /wms/:wmsid/inventory/bins/:inventoryname/:zoneid/:id",
        component: BinsInventoryWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/inventory/bins/:inventoryname/:zoneid/:id/:binsinventoryid/:rhid/:binsid/:binnumber",
        id: "wms_inventory_bins_scan",
        // name: "[WMS] Inventaire par bin - scan - /wms/:wmsid/inventory/bins/:inventoryname/:zoneid/:id/:binsinventoryid/:rhid/:binsid/:binnumber",
        component: BinsInventoryScanWms
    },
    // ─── Divers : rapport & périphériques ──────────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/report",
        id: "wms_report",
        // name: "[WMS] Rapport Power BI - /wms/:wmsid/report",
        component: WmsReport
    },
    {
        exact:true,
        path: "/wms/:wmsid/peripheral",
        id: "wms_peripheral",
        // name: "[WMS] Périphériques - /wms/:wmsid/peripheral",
        component: PeripheriqueWms
    },
    // ─── Notifications & historique (hors menu) ────────────────────────────────
    {
        exact:true,
        path: "/wms/:wmsid/notifications/list",
        id: "wms_notifications_list",
        // name: "[WMS] Liste des notifications - /wms/:wmsid/notifications/list",
        component: NotificationListWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/notifications/detail/:id",
        id: "wms_notifications_detail",
        // name: "[WMS] Détail notification - /wms/:wmsid/notifications/detail/:id",
        component: NotificationDetailWms
    },
    {
        exact:true,
        path: "/wms/:wmsid/notifications/licence-notification/:licenceNotificationId",
        id: "wms_notifications_licence_detail",
        // name: "[WMS] Détail notification licence - /wms/:wmsid/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
    {
        exact:true,
        path: "/wms/:wmsid/historique/edit/:id",
        id: "wms_historique_edit",
        // name: "[WMS] Détail historique - /wms/:wmsid/historique/edit/:id",
        component: HistoriqueDetail
    },
    // ─── Bons d'expédition (routes génériques - à garder en dernier) ───────────
    {
        exact:true,
        path: "/wms/:wmsid/:shipmentid",
        id: "wms_shipment_menu",
        // name: "[WMS] Menu d'un bon d'expédition - /wms/:wmsid/:shipmentid",
        component: ShipmentVoucherMenu
    },
    {
        exact:true,
        path: "/wms/:wmsid/:shipmentid/boxes-scan",
        id: "wms_shipment_boxes_scan",
        // name: "[WMS] Scan des cartons - /wms/:wmsid/:shipmentid/boxes-scan",
        component: BoxScan
    },
    {
        exact:true,
        path: "/wms/:wmsid/:shipmentid/items-scan",
        id: "wms_shipment_items_scan",
        // name: "[WMS] Scan des articles (carton ouvert) - /wms/:wmsid/:shipmentid/items-scan",
        component: BoxOpenScan
    },
    {
        exact:true,
        path: "/wms/:wmsid/:shipmentid/items-scan/:boxnumber",
        id: "wms_shipment_items_scan_box",
        // name: "[WMS] Scan des articles d'un carton - /wms/:wmsid/:shipmentid/items-scan/:boxnumber",
        component: ItemsScan
    },
    {
        exact:true,
        path: "/wms/:wmsid/:shipmentid/box-informations",
        id: "wms_shipment_box_informations",
        // name: "[WMS] Informations des cartons - /wms/:wmsid/:shipmentid/box-informations",
        component: BoxesInfos
    },
];

export default wmsRoutes;
